// @file Class names for slideshow
module.exports = {
  TITLE: {
    sm: 'slideshow-title-sm',
    md: 'slideshow-title-md',
    lg: 'slideshow-title-lg',
    xl: 'slideshow-title-xl',
    '2xl': 'slideshow-title-2xl',
  },

  BODY: {
    xs: 'slideshow-body-xs',
    sm: 'slideshow-body-sm',
    md: 'slideshow-body-md',
    lg: 'slideshow-body-lg',
    xl: 'slideshow-body-xl',
    '2xl': 'slideshow-body-2xl',
  },

  HEADING: {
    sm: 'slideshow-heading-sm',
    md: 'slideshow-heading-md',
    lg: 'slideshow-heading-lg',
    xl: 'slideshow-heading-xl',
    '2xl': 'slideshow-heading-2xl',
  },

  SUBHEADING: {
    md: 'slideshow-subheading-md',
    lg: 'slideshow-subheading-lg',
    xl: 'slideshow-subheading-xl',
  },

  CUSTOM_PROPERTIES_LABEL: {
    xs: 'slideshow-body-xs',
    sm: 'slideshow-body-sm',
    md: 'slideshow-body-md',
    lg: 'slideshow-body-lg',
    xl: 'slideshow-body-xl',
  },

  // use getter so we can safely use `this`
  get CUSTOM_PROPERTIES_VALUE() {
    return this.BODY
  },
}
